/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Seo_Trainer_Coaches_DescriptionInputs */

const en_seo_trainer_coaches_description = /** @type {(inputs: Seo_Trainer_Coaches_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: who coaches here, what they do and when they are free.`)
};

const pl_seo_trainer_coaches_description = /** @type {(inputs: Seo_Trainer_Coaches_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: kto tu prowadzi, czym się zajmuje i kiedy ma wolne terminy.`)
};

/**
* | output |
* | --- |
* | "{name}: who coaches here, what they do and when they are free." |
*
* @param {Seo_Trainer_Coaches_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_trainer_coaches_description = /** @type {((inputs: Seo_Trainer_Coaches_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Trainer_Coaches_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_trainer_coaches_description(inputs)
	return en_seo_trainer_coaches_description(inputs)
});